import { types } from '../types/types';
import { finishLoading, setError, startLoading, unsetError } from './ui';
import { login as loginRequest, authMe as authMeRequest, register as registerRequest } from '../helpers/auth-helper'
import { toAbsoluteApiUrl } from '../helpers/http-client';
import { getMenu } from './front';
import { setCompany } from './company';

export const authMe = ( token ) => {
    return async ( dispatch ) => {
        dispatch( startLoading() )
        dispatch( unsetError() )
        let resp = await authMeRequest( token )
        if(resp.success){
            dispatch( login( resp.data._id, resp.data.email, resp.data.name, resp.data.subscription, resp.token, {
                available: resp.data.available,
                photoUrl: toAbsoluteApiUrl(resp.data.photoUrl),
                phone: resp.data.phone,
                ticketSignature: resp.data.ticketSignature,
                active: resp.data.active,
                role: resp.data.role,
            } ) )
            dispatch( setCompany( resp.data.company._id, resp.data.company.name, resp.data.company.subscription, resp.data.company.storage, resp.data.company.adminEmailVerified, resp.data.company.settings ) )
            await getMenu( resp.token )( dispatch )
        }
        dispatch( finishLoading() )
    }
}

export const startRegister = ( company, firstName, lastName, email, password ) => {
    return async ( dispatch ) => {
        dispatch( startLoading() )
        dispatch( unsetError() )
        let resp = await registerRequest( company, firstName, lastName, email, password )
        if(resp.success){
            dispatch( login( resp.data._id, resp.data.email, resp.data.name, resp.data.subscription, resp.token, {
                available: resp.data.available,
                photoUrl: toAbsoluteApiUrl(resp.data.photoUrl),
                phone: resp.data.phone,
                ticketSignature: resp.data.ticketSignature,
                active: resp.data.active,
                role: resp.data.role,
            } ) )
            dispatch( setCompany( resp.data.company._id, resp.data.company.name, resp.data.company.subscription, resp.data.company.storage, resp.data.company.adminEmailVerified, resp.data.company.settings ) )
            await getMenu( resp.token )( dispatch )
        }else{
            dispatch(setError(resp.message || 'Error en el registro'))
        }
        dispatch( finishLoading() )
    }
}

export const startLogin = ( email, password ) => {
    return async ( dispatch ) => {
        dispatch( startLoading() )
        dispatch( unsetError() )
        let resp = await loginRequest( email, password )
        if(resp.success){
            dispatch( login( resp.data._id, resp.data.email, resp.data.name, resp.data.subscription, resp.token, {
                available: resp.data.available,
                photoUrl: toAbsoluteApiUrl(resp.data.photoUrl),
                phone: resp.data.phone,
                ticketSignature: resp.data.ticketSignature,
                active: resp.data.active,
                role: resp.data.role,
            } ) )
            dispatch( setCompany( resp.data.company._id, resp.data.company.name, resp.data.company.subscription, resp.data.company.storage, resp.data.company.adminEmailVerified, resp.data.company.settings ) )
            await getMenu( resp.token )( dispatch )
        }else{
            dispatch(setError(resp.message || 'Error en el login'))
        }
        dispatch( finishLoading() )
    }
}

export const login = ( id, email, name, subscription, token, profile = {} ) => {
    const {
        available = true,
        photoUrl = '',
        phone = '',
        ticketSignature = '',
        active = true,
        role = 'USER',
    } = profile || {};

    return {
        type: types.login,
        payload: {
            id,
            email,
            name,
            subscription,
            token,
            available,
            photoUrl,
            phone,
            ticketSignature,
            active,
            role,
        }
    }
}

export const setAuthAvailability = ( available ) => {
    return {
        type: types.setAuthAvailability,
        payload: {
            available: Boolean(available),
        },
    }
}

export const setAuthProfile = (payload = {}) => {
    return {
        type: types.setAuthProfile,
        payload,
    };
}

export const logout = () => {
    localStorage.removeItem('finanAuth');
    return {
        type: types.logout,
    }
}
